<template>
  <div class="w-full">
    <div class="grid grid-cols-2 gap-4">
      <div class="col-span-2 md:col-span-1 bg-white rounded-lg overflow-hidden shadow-md">
        <div class="flex flex-row items-center justify-between p-4">
          <h1 class="text-lg">Current Account Balance</h1>
        </div>

        <div class="px-4 pb-4 focus-within:font-medium text-4xl">
          {{ earningsBalance | displayMoney }}
        </div>
      </div>
      <div class="col-span-2 md:col-span-1 bg-white rounded-lg overflow-hidden shadow-md">
        <div class="flex flex-row items-center justify-between p-4">
          <h1 class="text-lg">Lifetime Earnings</h1>
        </div>

        <div class="px-4 pb-4 focus-within:font-medium text-4xl">
          {{ lifetimeEarnings | displayMoney }}
        </div>
      </div>
    </div>

    <div class="-mx-4 mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr class="hidden lg:table-row">
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-8"></th>
            <th scope="col" class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
              ID
            </th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Month
            </th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Earnings
            </th>
            <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">
              Status
            </th>
            <th scope="col" class="hidden relative py-3.5 pl-3 pr-4 sm:pr-6 lg:table-cell">
              <span class="sr-only">View Report</span>
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="report in reports" v-bind:key="report.granularity_id">
            <td class="px-3 py-4 text-sm text-gray-500">
              <div class="w-8 flex justify-center">
                <img
                  src="data:image/png;base64,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"
                  class="w-auto h-4" />
              </div>
            </td>
            <td class="w-full max-w-0 px-3 py-4 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none ">
              {{ report.publicId }}
              <dl class="font-normal lg:hidden">
                <dt class="mt-1 truncate text-gray-700">
                  {{ report.granularity_id | displayMonth }}
                </dt>
                <dd class="mt-1 truncate text-gray-700">
                  {{ report.stringer_earnings | displayMoney }}
                </dd>
                <router-link :to="{
                  name: 'StringerSocialIncomeReport',
                  params: {
                    granularityId: report.granularity_id,
                    reportId: report.id
                  }
                }" class="text-blue-600 hover:text-blue-900 text-sm">View</router-link>
              </dl>
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
              {{ report.granularity_id | displayMonth }}
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
              {{ report.stringer_earnings | displayMoney }}
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">
              {{ report.status | capitalize }}
            </td>
            <td class="hidden py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 lg:table-cell">
              <router-link :to="{
                name: 'StringerSocialIncomeReport',
                params: {
                  granularityId: report.granularity_id,
                  reportId: report.id
                }
              }" class="text-blue-600 hover:text-blue-900 text-sm">View</router-link>
            </td>
          </tr>
          <tr v-if="reports.length == 0">
            <td class="px-3 py-4 text-center" colspan="6">
              No reports are available.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-4 text-sm text-gray-600">As of September 2022, Live Storms Media now shares ad revenue with content
      creators. New reports are generally available by the seventh of each month and are time-lagged by two months.
      Example: November's report will become available at the beginning of January. If you have specific questions
      regarding your report, open a ticket with "Social Revenue Share" category.</p>
  </div>
</template>

<script>
import * as Config from "@/config";

import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Card from "@/components/partials/Card";
import CustomTable from "@/components/general/CustomTable";
import Dropdown from "@/components/partials/Dropdown";

export default {
  name: "SocialIncomeMain",
  data() {
    return {
      lifetimeEarnings: 0,
      earningsBalance: 0,
      reports: []
    };
  },
  mounted() {
    this.getSocialReports();
  },
  methods: {
    async getSocialReports() {
      try {
        let res = await this.$http.get(
          Config.apiPath + "/api/v2/stringer/social-reports/overview"
        );
        this.reports = res.data.reports;
        this.polling = false;
        this.lifetimeEarnings = res.data.lifetimeEarnings;
        this.earningsBalance = res.data.earningsBalance;
      } catch (e) {
        console.log(e);
      }
    }
  },
  filters: {
    displayMoney: function (value) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });
      return formatter.format(value);
    },
    displayMonth: function (data) {
      return moment(data, "YYYYMM").format("MMMM");
    },
  }
};
</script>
